<div class="sidebar-title">NAVEGAÇÃO</div>
<mat-nav-list dense class="sidebar-navigation">
  <ng-container *ngFor="let m of menu">
    <div *ngIf="m.show && m.type === 'section'" class="sidebar-section">{{ m.text }}</div>
    <a mat-list-item *ngIf="m.show && m.type !== 'section' && (!m.children || m.children.length === 0)"
      [routerLink]="m.routerLink"
      routerLinkActive="active"
      [disabled]="!m.enable"
      (click)="closeNav()">
      <mat-icon *ngIf="m.icon">{{ m.icon }}</mat-icon>
      <span>{{ m.text }}</span>
    </a>
    <app-sub-menu *ngIf="m.show && m.type !== 'section' && m.children && m.children.length > 0"
      [menu]="m"
      (onItemClick)="closeNav()"></app-sub-menu>
  </ng-container>
</mat-nav-list>
